import Codeplus from ".";

// Make accesible to the browser window
window.Codeplus = Codeplus;
